import { en2ur, enSentences } from "./en";
import { DEFAULT_EN } from "../LTRView";
import { LANG_ENG, LANG_URD } from "../../../helpers/translate";

export const EVT_LTR_MOUSEOVER = "ltr.mouseOver";
export const EVT_LTR_MOUSEOUT = "ltr.mouseOut";
export const EVT_RTL_MOUSEOVER = "rtl.mouseOver";
export const EVT_RTL_MOUSEOUT = "rtl.mouseOut";
export const EVT_LTR_TRANSLATED = "ltr.translated";
export const EVT_COPY_TRANSLATION = "copy.translation";

export const cache: Record<string, Record<string, Record<string, string>>> = {
    [LANG_ENG]: {
        [LANG_URD]: {
            [DEFAULT_EN]: "انگریزی سے ترجمعے کے لیے کچھ متن لکھیں.",
        },
    },
};

export async function translate(
    text: string,
    from: string = LANG_ENG,
    to: string = LANG_URD
) {
    if (from === LANG_ENG) {
        return en(text, to);
    }
}

export async function en(text: string, to: string) {
    try {
        if (to === LANG_URD) {
            return await en2ur(enSentences(text));
        }

        throw new Error(`translation not available, from: en, to: ${to}`);
    } catch (e) {
        console.warn("translate:en");
        console.warn(e);
    }
}

export function updateCache(
    src_lang: string,
    src_text: string,
    dst_lang: string,
    dst_text: string
) {
    cache[src_lang][dst_lang][src_text] = dst_text;
}

export function setFocusClass(
    elm: HTMLElement,
    childIndex: number,
    status: boolean
) {
    if (!elm) {
        return;
    }

    if (status) {
        const t = elm.childNodes[childIndex] as HTMLElement;
        if (t && t.className) {
            t.className = "focus";
        }
    } else {
        for (let i = 0, len = elm.childNodes.length; i < len; i += 1) {
            const n = elm.childNodes[i] as HTMLElement;
            if (n) {
                n.className = "";
            }
        }
    }
}
